import * as L from 'leaflet';
import { MapLayer } from './mapLayer.abstract';

// options: http://leafletjs.com/reference-1.2.0.html#tilelayer
export class TileLayer extends MapLayer {
  public url: string;

  constructor(id: string, name?: string) {
    super(id, name);
    // Default options
    this.options.setOptions({
      pane: 'tilePane',
    });
  }

  public setUrl(url: string): this {
    this.url = url;
    return this;
  }

  public getLeafletLayer(): Promise<null | L.Layer> {
    return Promise.resolve(new L.TileLayer(this.url, this.options.getAll()));
  }
}
